var map = {
	"./assessment.json": [
		18012,
		8012
	],
	"./assessmentCenter.json": [
		27305
	],
	"./audit.json": [
		62589,
		2589
	],
	"./auth.json": [
		23468
	],
	"./breach.json": [
		7471,
		7471
	],
	"./classification.json": [
		65710
	],
	"./clusteringV2.json": [
		70296
	],
	"./common.json": [
		49279
	],
	"./compliance.json": [
		75645,
		5645
	],
	"./consent.json": [
		51376
	],
	"./dashboard.json": [
		29242,
		9242
	],
	"./dataflow.json": [
		97198,
		7198
	],
	"./discovery.json": [
		46096
	],
	"./dpa.json": [
		84997,
		4997
	],
	"./dpia.json": [
		5680,
		5680
	],
	"./dpo.json": [
		70847,
		847
	],
	"./dpoCuration.json": [
		79584,
		9584
	],
	"./dpta.json": [
		39013,
		9013
	],
	"./dsr-subject-landing.json": [
		75460
	],
	"./dsr.json": [
		2455,
		2455
	],
	"./license.json": [
		6333
	],
	"./notification.json": [
		8121
	],
	"./organization.json": [
		41621,
		1621
	],
	"./pdplAssessment.json": [
		37316,
		7316
	],
	"./privacyNotices.json": [
		16332,
		3951
	],
	"./privilegeReview.json": [
		94249,
		4249
	],
	"./reports.json": [
		96025,
		6025
	],
	"./risk.json": [
		77105,
		7105
	],
	"./ropa.json": [
		85946
	],
	"./scanner.json": [
		80588,
		588
	],
	"./settings.json": [
		93443
	],
	"./users.json": [
		37866,
		7866
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 15875;
module.exports = webpackAsyncContext;